import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { DynamicFieldModel } from '@share';
import { Validators } from '@angular/forms';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { SurveyService } from './survey.service';
import { dynamicDateRangeValidator } from 'src/app/share/validators/dynamic-daterange-validator';

@Component({
  selector: 'app-survey',
  imports: [DynamicTableComponent],
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss'
})
export class SurveyComponent {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Survey List",
    permissionKey: "survey",
    enableDelete: false,
    enableEdit: true,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px"

      },
      {
        key: "survey_link",
        title: "link",
        type: "string",
        enableSearch: false,
        searchType: "input",
        width: "400px",

      },

      {
        key: "start_date",
        title: "Start Date",
        type: "date",
        enableSearch: false,
        searchType: "date",
        width: "150px",

      },
      {
        key: "end_date",
        title: "End Date",
        type: "date",
        enableSearch: false,
        searchType: "date",
        width: "150px",
      },
      {
        key: "status",
        title: "Active",
        type: "string",
        enableSearch: false,
        searchType: "date",
        width: "100px",
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

//   groupLevelValidators = [
//   {
//     validator: 'dateRange',
//     fields: ['start_date', 'end_date'],
//   }
// ];

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'link',
      name: 'survey_link',
      type: 'input',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Survey Link required',
        },
      ],
    },
    {
      label: 'Start Date',
      name: 'start_date',
      type: 'date',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Start Date required',
        },
        // {
        //   name: 'dateRange',
        //   validator: dynamicDateRangeValidator('end_date'),
        //   message: 'Start Date must be before End Date',
        // }
      ],
    },
    {
      label: 'End Date',
      name: 'end_date',
      type: 'date',
      placeholder: '',

      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'End Date required',
        },{
          name: 'dateRange',
          validator: dynamicDateRangeValidator('start_date'),
          message: 'End Date must be after Start Date',
        }
      ],
      
      //groupValidators: this.groupLevelValidators
    },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      class: 'col-md-6',
      placeholder: 'Content',
      required: true,
      options: [
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' },
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Status required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: '',
    }
  ];

  

  constructor(private loadingService: LoadingService, private service: SurveyService) {
  }

  ngOnInit(): void {
    let params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());
    this.loadData(params);
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading()
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.totalCount;
      },
      error: err => this.loadingService.toggleTableLoading(),
      complete: () => this.loadingService.toggleTableLoading()
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
